import React, { useState } from 'react';
import { Popover, IconButton, Box } from '@mui/material';
import HelpRounded from '@mui/icons-material/HelpRounded';

const HelpIconPopover = ({ htmlContent }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const open = Boolean(anchorEl);

    return (
        <>
            <IconButton
                onClick={handleClick}
                size="small"
                sx={{
                    ml: 1,
                    alignSelf: 'center',
                    color: '#6728AF',
                    padding: '0px',
                    marginLeft: '0px'
                }}
            >
                <HelpRounded fontSize="small" />
            </IconButton>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{ sx: { borderRadius: 2, boxShadow: 3 } }}
            >
                <Box sx={{ p: 2, maxWidth: 280 }}>
                    <div
                        style={{ fontSize: '0.875rem', lineHeight: '1.4' }}
                        dangerouslySetInnerHTML={{ __html: htmlContent }}
                    />
                </Box>
            </Popover>
        </>
    );
};

export default HelpIconPopover;